import { Inject, inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable, of, take, timeout } from 'rxjs';
import { AUTH_STATE } from '../firebase.providers';
import { User } from 'firebase/auth';

// Waits for the resolved Firebase auth state instead of reading the service's seeded
// subjects. On a full page load those are still false, which bounced logged-in members
// off /reserveer and /mijn-reservaties (refresh or deep link). Fails closed to /login.
@Injectable({
  providedIn: 'root',
})
export class AuthCheckService {
  constructor(
    @Inject(AUTH_STATE) private authState: Observable<User | null>,
    private router: Router,
  ) {}

  /** `requestedUrl` is carried to /login as returnUrl so signing in lands on the page
   *  that was asked for, instead of dropping everyone on the reserve flow. */
  canActivate(requestedUrl: string): Observable<boolean | UrlTree> {
    return this.authState.pipe(
      take(1),
      timeout({ first: 5000, with: () => of(null) }),
      map((user) =>
        user && user.emailVerified
          ? true
          : this.router.createUrlTree(['/login'], {
              queryParams: { returnUrl: requestedUrl },
            }),
      ),
    );
  }
}

export const AuthGuard: CanActivateFn = (_route, state) =>
  inject(AuthCheckService).canActivate(state.url);
